// Countries Curipod treats as native-English-speaking. Used throughout the
// home page and onboarding to decide whether to surface the English /
// Literacy / native-language subject options, and which default subject to
// use. Single source of truth — keep this list in this file only.
export const NATIVE_ENGLISH_COUNTRIES = [
  'US',
  'UK',
  'GB',
  'AU',
  'IE',
  'NZ',
  'CA',
] as const;

export function isInternationalCountry(country: string | undefined): boolean {
  if (!country) return false;
  return !NATIVE_ENGLISH_COUNTRIES.includes(
    country.toUpperCase() as typeof NATIVE_ENGLISH_COUNTRIES[number],
  );
}
